<template>
  <div class="agreement">
    <div class="title">JoyOrders 服务协议</div>
    <p class="ps">
      本协议是您与上海悦单网络科技有限公司(以下称 “JoyOrders”) 之间的约束性协议。适用于您使用 (1)
      <a href="www.joyorders.com">www.joyorders.com</a>以及其子域 、由 JoyOrders 或其附属公司托管的任何网站。(2) JoyOrders 微信小程序
    </p>
    <p></p>
    <p class="ps">买单人用户定义：买单人是我们 JoyOrders 的下单服务的服务对象, 是海外购物的消费者和最终付款人, 也是下单服务的付款人。（以下称买单人）</p>
    <p></p>
    <p class="ps">下单人用户定义：下单人是帮买单人在海外商家下单的服务方, 提供商家沟通/下单/转运代操作等服务。（以下称下单人）</p>
    <p></p>
    <p class="t4">一.协议概述</p>
    <p></p>
    <p
      class="ps"
    >本协议内容包括协议正文及所有 JoyOrders 已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。您只有在能够与 JoyOrders 形成有约束力的合同，以及当您遵守或符合本协议的条款和所有适用的法律法规时，才可以获取或使用 JoyOrders 的产品以及服务。如果您代表的某个实体或个人接受本协议条款，您确认并保证您拥有使此类实体或个人受到本协议全部条款的约束的法定权力。您对任何授权用户遵守本协议全部条款负责。</p>
    <p></p>
    <p
      class="ps"
    >如果您是授权用户，您确认并保证已年满 13 周岁（或年满您所居住的司法管辖区，或获取并使用所述软件所在的司法管辖区的最低法定年龄），如果您的年龄在 13 周岁（或年满您所居住的司法管辖区，或获取并使用所述软件所在的司法管辖区的最低法定年龄）和您所居住的司法管辖区（或获取并使用所述软件所在的司法管辖区）的法定成年年龄之间，您需在父母或法定监护人同意并接受本协议约束的情况下使用所述软件。任何不满 13 周岁（或不满您所居住的司法管辖区，或获取并使用所述软件所在的司法管辖区的最低法定年龄）的个人获取并使用所述软件违反本协议规定，并被严格禁止。</p>
    <p></p>

    <p class="t4">二.平台服务</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 提供在线互助平台，帮助买单人在其他网站进行下单购买，在 JoyOrders 平台上提供的商品、服务、广告信息等 JoyOrders 不保证其设置的准确性和完整性，同时对于外部指向链接内容 JoyOrders 不承其真实有效性，且对于其不承担任何责任。JoyOrders 服务的内容可能涉及由第三方个人或单位提供，该等包含的第三方所提供的服务品质及内容由第三方自行负责；用户应当知晓并按照第三方服务协议使用第三方服务。第三方的内容、商品、服务、广告和其他任何信息均需由用户自行判断并承担风险，JoyOrders 不保证其内容及网络服务的及时性、安全性、准确性，若因此引发任何争议或损害，JoyOrders对此不承担责任。</p>
    <p></p>
    <p class="t4">三.物流仓储</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 不直接提供仓储物流服务，下单人将商家/转运公司/物流公司等物流号告知 JoyOrders，JoyOrders 提供互联网物流信息追踪查询服务，JoyOrders 所提供的物流信息仅供参考，具体详情及解释归所属商家/转运公司/物流公司为准。</p>
    <p></p>
    <p
      class="ps"
    >对于下单服务中所产生的错发，漏发，破损商品等意外情况都依据商家/转运公司/物流公司等所示条款以及与下单人的约定协商处理，JoyOrders 没有直接以及间接、附带、特殊衍生责任。 JoyOrders 不承担直接以及间接、附带、特殊衍生损失和相应所产生的赔偿责任。JoyOrders 对于任何原因造成的产品遗失、损坏、延迟送达、误送、未送达、错误资料、清关问题不负任何责任。</p>
    <p></p>
    <p class="t4">四.下单人责任</p>
    <p></p>
    <p
      class="ps"
    >当您在 JoyOrders 平台提供下单服务时，请您务必确认核实您所提供的服务时间、内容、限制性要求等重要事项，您需要对您提供的服务负有法律责任，当买单人对于服务内容有疑时，JoyOrders 将依据您在平台上所提供的服务信息来核实调处。</p>
    <p></p>
    <p class="t4">五.买单人责任</p>
    <p></p>
    <p
      class="ps"
    >当买单人在 JoyOrders 平台选择下单人提供的服务时，买单人务必仔细确认其所购商品的品名、价格、数量、型号、规格、尺寸和服务的时间、内容、限制性要求等重要事项，并在发布任务时核实买单人的联系地址、电话、收货人等信息。如买单人填写的收货人非本人，则该收货人的行为和意思表示产生的法律后果均由买单人承担。</p>
    <p></p>
    <p
      class="ps"
    >买单人的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施恶意购买、恶意维权等扰乱 JoyOrders 平台正常交易秩序的行为。基于维护 JoyOrders 平台交易秩序及交易安全的需要， JoyOrders 发现上述情形时可主动执行关闭相关交易订单等操作。</p>
    <p></p>
    <p class="t4">六.交易争议处理</p>
    <p></p>
    <p class="ps">【交易争议处理途径】您在 JoyOrders 平台交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：</p>
    <p></p>
    <p class="ps">（1）与争议相对方自主协商；</p>
    <p class="ps">（2）寻找 JoyOrders 平台客服进行调处服务；</p>
    <p class="ps">（3）请求消费者协会或者其他依法成立的调解组织调解；</p>
    <p class="ps">（4）向有关行政部门投诉；</p>
    <p class="ps">（5）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</p>
    <p class="ps">（6）向人民法院提起诉讼。</p>
    <p></p>
    <p
      class="ps"
    >【平台调处服务】如您依据 JoyOrders 平台规则寻找 JoyOrders 平台客服进行争议调处服务，则表示您认可并愿意履行 JoyOrders 平台规则，客服人员可以根据其所了解到的争议事实并依据 JoyOrders 平台规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在 JoyOrders 客服调处决定作出前，您可选择上述（三）、（四）、（五）、（六）途径（下称“其他争议处理途径”）解决争议以中止 JoyOrders 客服争议调处服务。如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。</p>
    <p></p>
    <p class="t4">七.更改取消支付</p>
    <p></p>
    <p class="ps">当结账服务产生且下单人开始在商家下单后，我们不接受您的订单取消或者更改，也无法退回已经处理的款项</p>
    <p></p>
    <p class="t4">八.版权</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 上所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计、在广告中的全部内容、商品以及其它信息均由 JoyOrders 或其他权利人依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。非经 JoyOrders 或其他权利人书面同意，您不得擅自使用、修改、全部或部分复制、公开传播、改变、散布、发行或公开发表、转载、引用、链接、抓取或以其他方式使用本平台程序或内容。如有违反，您同意承担由此给JoyOrders或其他权利人造成的一切损失。</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 不保证平台上由其他权利人提供的所有内容没有侵犯任何第三方的合法权益，如您认为前述内容侵犯您的合法权益，请及时与 JoyOrders 客服联系，JoyOrders 将在法律规定范围内协助您解决问题。</p>
    <p></p>
    <p class="t4">九.不可预见的情况免责声明</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，JoyOrders 并不承担相应的违约责任：</p>
    <p></p>
    <p class="ps">因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
    <p></p>
    <p class="ps">因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
    <p></p>
    <p class="ps">在 JoyOrders 已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
    <p></p>
    <p class="t4">十.贸易限制</p>
    <p></p>
    <p
      class="ps"
    >针对通过 JoyOrders 平台取得的商品、服务、软件及技术（包括 JoyOrders 平台提供的软件及技术），您承诺遵守所有适用的进出口管制、贸易限制与经济制裁相关法律法规。基于维护 JoyOrders 平台交易秩序及交易安全的需要，如您违反前述承诺的， JoyOrders 可在发现上述情形时主动执行关闭相关交易订单及作出账户处置等操作。</p>
    <p></p>
    <p class="t4">十一.费用</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 为 JoyOrders 平台向您提供的服务付出了大量的成本，除 JoyOrders 平台明示的收费业务外， JoyOrders 向您提供的服务目前是免费的。如未来 JoyOrders 向您收取合理费用， JoyOrders 会采取合理途径并以足够合理的期限提前通过法定程序并以本协议第12条约定的方式通知您，确保您有充分选择的权利。</p>
    <p></p>
    <p class="t4">十二.通知</p>
    <p></p>
    <p class="t4">12.1 有效联系方式</p>
    <p></p>
    <p
      class="ps"
    >在注册成为 JoyOrders 平台的用户，接受 JoyOrders 平台服务时，应该向 JoyOrders 提供真实有效的联系方式（包括电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，有义务及时更新有关信息，并保持可被联系的状态。</p>
    <p></p>
    <p class="ps">在注册 JoyOrders 平台用户时生成的用于登陆 JoyOrders 平台接收系统消息，小程序和公众号消息，也作为有效联系方式。</p>
    <p></p>
    <p class="ps">JoyOrders 将向上述联系方式的其中之一或其中若干向用户送达各类通知，而此类通知的内容可能对用户的权利义务产生重大的有利或不利影响，请务必及时关注。</p>
    <p></p>
    <p
      class="ps"
    >通过注册时填写的手机号码或者电子邮箱有权获取感兴趣的商品广告信息、促销优惠等商业性信息；如果不愿意接收此类信息，有权通过 JoyOrders 提供的相应的退订功能进行退订。</p>
    <p></p>
    <p class="t4">12.2 通知的送达</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在 JoyOrders 平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送系统消息，小程序消息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</p>
    <p></p>
    <p
      class="ps"
    >对于在 JoyOrders 平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在JoyOrders 平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册 JoyOrders 用户时生成的账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</p>
    <p></p>
    <p class="ps">您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</p>
    <p></p>
    <p class="ps">您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。</p>
    <p></p>
    <p
      class="ps"
    >你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</p>
    <p></p>
    <p class="t4">十三. 法律适用、管辖与其他</p>
    <p></p>
    <p class="ps">【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</p>
    <p></p>
    <p
      class="ps"
    >【管辖】您因使用 JoyOrders 平台服务所产生及与 JoyOrders 平台服务有关的争议，由 JoyOrders 与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</p>
    <p></p>
    <p class="ps">【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
    <p></p>
  </div>
</template>

<script>
export default {
  name: 'private-aggrement'
}
</script>

<style scoped lang="less">
.agreement {
  // white-space: pre-wrap;
  max-width: 1160px;
  margin: 30px auto;
  font-size: 16px;
  .title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin: 20px auto;
  }
  a {
    font-size: 16px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    display: block;
    min-height: 20px;
  }
  .ps {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .em {
    font-weight: 700;
  }
  .t4 {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/treaty/UserAgreement.vue